import React from "react";
import Card from "react-bootstrap/Card";

import './Resume.css'
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Badge from "react-bootstrap/Badge";

function Resume_Top() {
  return (
    <>
        <div>
                <h1 className="text-left font-weight-bold top-font">
                  Hello,
                </h1>
                <p className="text-left top-font">
                  <span className="h3">
                    a bit about me :
                  </span>
                </p>

                <Row>
                  <Col>
                    <div className="d-flex">
                      <Badge pill bg="white" border="1px solid #66CDAA" className={"resume-badges"}>
                        #ESFJ
                      </Badge>
                    </div>
                  </Col>
                  <Col>
                    <div className="d-flex">
                      <Badge pill bg="white" border="1px solid #66CDAA" className={"resume-badges"}>
                        #꾸준함
                      </Badge>
                    </div>
                  </Col>
                  <Col>
                    <div className="d-flex">
                      <Badge pill bg="white" border="1px solid #66CDAA" className={"resume-badges"}>
                        #기록과 정리
                      </Badge>
                    </div>
                  </Col>
                </Row>

                <p className="text-left" style={{ marginTop: "5%" }}>
                  <span
                    className="h6"
                    style={{ fontFamily: "Noto Sans KR", color: "white" }}>
                    작은 양이라도 <b>꾸준히</b> 하면 해낼 수 있다는 것을
                    믿는 사람입니다. <br></br> 목표하고, 또 그 목표를 <b>성취</b>
                    하는 것을 사랑합니다. <br></br> <i>엑셀, 워드, PPT...</i>{" "}
                    <b>문서 작업</b>을 하는 것을 너무나도 좋아합니다. <br></br>{" "}
                    완벽주의자와는 거리가 멉니다. 저는 <b>완성주의자</b>입니다.{" "}
                    <br></br>

                    <hr></hr>

                    <i>
                      <b>첨언</b>
                    </i>{" "}
                    <br></br>

                    <b>1.</b> 놀랍게도 지난 <b>21년간 ENFP</b>로 살아왔습니다.{" "}
                    <br></br>
                    <b>2.</b> <b>1년</b>만에 <b>24kg</b>를 뺐고 지금 유지 중입니다.{" "}
                    <br></br>
                    <b>3.</b> 가장 좋아하는 음식은 <b>라면</b>입니다. 맛있고 간편하잖아요?<br></br>

                  </span>
                </p>
              </div>
    </>
  );
}

export default Resume_Top;
